import React from "react";
import {
    ProgressRoot,
    ProgressTrack,
    ProgressIndicator,
    ProgressValue,
} from "@design-system/ProgressBar/ProgressBar";
import styles from "./RevertProgressToast.module.scss";

interface Props {
    label: string;
    processed?: number;
    total?: number;
}

export const RevertProgressToast: React.FC<Props> = ({
    label,
    processed,
    total,
}) => {
    const hasProgress =
        total !== undefined && total > 0 && processed !== undefined;
    const progress = hasProgress
        ? Math.min(Math.floor((100 * processed) / total), 100)
        : 0;

    return (
        <div className={styles.container}>
            <p className={styles.label}>{label}</p>
            {hasProgress && (
                <section className={styles.progress}>
                    <ProgressRoot value={progress}>
                        <ProgressTrack>
                            <ProgressIndicator />
                        </ProgressTrack>
                        <ProgressValue />
                    </ProgressRoot>
                </section>
            )}
        </div>
    );
};
